import { createAsyncAction } from '../../actions';
import BusinessSelectors from '../../business/selectors';
import { BusinessActions } from '../../index';
import ModalsActions from '../../modals/actions';

const removeEncryptedMnemonic = createAsyncAction(
  'WALLET_REMOVE_ENCRYPTED_MNEMONIC',
  function() {
    return async(dispatch, getState) => {
      const state = getState();
      const business = BusinessSelectors.getCurrent(state);
      try {
        if (!business) {
          throw new Error('Unfortunately current business wasn\'t found');
        }

        await dispatch(BusinessActions.UPDATE_BUSINESS_INFO({
          mnemonic: null,
          id: business.get('id'),
          business_id: business.get('id'),
        }));

        dispatch(this.success());
        dispatch(ModalsActions.CLOSE_TRANSFER_MNEMONIC_WITH_CALLBACK());
      } catch (error) {
        dispatch(this.failed(error));
        throw error;
      }
    };
  },
);

export default removeEncryptedMnemonic;
